// extracted by mini-css-extract-plugin
export var exchangeLogo = "exchangeDetail-module--exchangeLogo--j4LVN";
export var descriptionTitle = "exchangeDetail-module--descriptionTitle--GTwe0";
export var description = "exchangeDetail-module--description--mTyCQ";
export var noDataCard = "exchangeDetail-module--noDataCard--6t51g";
export var noDataCardContent = "exchangeDetail-module--noDataCardContent--weBgf";
export var mobileMarginTop = "exchangeDetail-module--mobileMarginTop--ZIj6Q";
export var aTagButton = "exchangeDetail-module--aTagButton--CtpB8";